import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { authApi } from "../api";
import { localVariables } from "../utils/constants"
import { routesPath } from "../utils/routesPath"

const RequireAuth = ({ children }) => {
    const { accessToken, accessTokenExp } = useSelector((state) => state.auth);    
    const location = useLocation();
    const tokenExpired = accessTokenExp * 1000 < new Date().getTime();

    if (!accessToken || tokenExpired) {
        localStorage.setItem(localVariables.REMEMBER_PATH, location.pathname + (location.search || ''));
        authApi.clearAuthData()
        return (
            <Navigate
                to={`../${routesPath.AUTH.LOGIN}`}
                state={{ from: location }}
                replace
            />
        );
    }

    return children
}

export default RequireAuth